import Exam from '@/models/Exam';
import { Model, Nullable } from '@/models/Model';
import User from '@/models/User';

export enum StudentExamCorrectionStatusEnum {
  PENDING = 'PENDING',
  CORRECTED = 'CORRECTED',
}

export type StudentExamStudent = Pick<
  User,
  'id' | 'firstName' | 'lastName' | 'username'
>;

export default interface StudentExam extends Model {
  exam: Exam;
  student: StudentExamStudent;
  klassId: number;
  opensAt: string;
  closesAt: string;
  maxTime: number;
  timeSpent: Nullable<number>;
  grade: Nullable<number>;
  maxGrade: Nullable<number>;
  finishedAt: Nullable<string>;
  correctedAt: Nullable<string>;
  lastCorrectedById: Nullable<number>;
}
